// @flow
import type { Action } from '../../core/types'
import type {
  EntityDict,
  MergeAction,
  RemoveManyAction,
  RemoveAllAction,
  UpdateAction
} from './types'
import * as ActionTypes from './actionTypes'

export function mergeEntities(entityMap: EntityDict): MergeAction {
  return {
    type: ActionTypes.MERGE,
    payload: entityMap
  }
}

/**
 * Removes multiple entities at once (of a single type/domain)
 * @param keys {Array}
 */
export function removeMany(
  domain: string,
  keys: Array<string>
): RemoveManyAction {
  return {
    type: ActionTypes.REMOVE,
    payload: {
      domain,
      keys
    }
  }
}

export function removeOne(domain: string, key: string): RemoveManyAction {
  return removeMany(domain, [key])
}

/* Clears all entities by domain */
export function removeAll(domain: string): RemoveAllAction {
  return {
    type: ActionTypes.REMOVE_ALL,
    payload: {
      domain
    }
  }
}

/* Empties the whole entity cache */
export function reset(): Action {
  return {
    type: ActionTypes.RESET
  }
}

export function update(domain: string, id: string, data: Object): UpdateAction {
  return {
    type: ActionTypes.UPDATE,
    payload: {
      domain,
      id,
      data
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/entities/actions.js